import React, { useState, useEffect } from 'react';
import Logo from './Logo';

const LoadingAnimation = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading completion after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Logo Loading Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
        <div className="text-center">
          <Logo isLoading={isLoading} />
          <div className="mt-4 space-y-2">
            <div className="villa-skeleton h-2 w-24 mx-auto rounded-full"></div>
            <div className="villa-skeleton h-2 w-16 mx-auto rounded-full"></div>
          </div>
        </div>
      </div>

      {/* Villa Card Skeletons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-8 px-3">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
          <div key={index} className="villa-skeleton rounded-lg overflow-hidden">
            <div className="villa-skeleton-image"></div>
            <div className="p-4">
              <div className="villa-skeleton-text"></div>
              <div className="villa-skeleton-text villa-skeleton-text-short"></div>
              <div className="flex justify-between mt-4">
                <div className="villa-skeleton-text villa-skeleton-text-short"></div>
                <div className="villa-skeleton-text villa-skeleton-text-short"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingAnimation;